import {mapGetters} from 'vuex'

// 将滚动条混入添加到全局混入中
export default {
    data() {
        return {
            timer: null,
            scrollbarWidth: 0,
            scrollbarHeight: 0,
            hasScrollbar: false
        }
    },
    computed: {
        ...mapGetters(['is_check'])
    },
    mounted() {
        this.updateScrollbarInfo();
        this.$nextTick(() => {
            // 监听滚动条变化
            this.observeScrollbarChanges();
        });
    },
    beforeDestroy() {
        // 清理观察器
        if (this.scrollbarObserver) {
            this.scrollbarObserver.disconnect();
        }
    },
    methods: {
        /**
         * 动态设置元素样式以补偿滚动条
         * @param {HTMLElement} element - 目标元素
         * @param {string} type - 补偿类型
         */
        applyScrollbarCompensation(element, type = 'margin') {
            if (!element || !this.hasScrollbar) return;

            const styles = this.getScrollbarCompensation(type);
            Object.assign(element.style, styles);
        },
        /**
         * 获取滚动条补偿样式
         * @param {string} type - 补偿类型 ('margin', 'padding', 'fixed')
         * @returns {object} 样式对象
         */
        getScrollbarCompensation(type = 'margin') {
            if (!this.hasScrollbar) return {};

            const width = this.scrollbarWidth;

            switch (type) {
                case 'margin':
                    return {marginRight: `-${width}px`};
                case 'padding':
                    return {paddingRight: `${width}px`};
                case 'fixed':
                    return {right: `${width}px`};
                case 'width':
                    return {width: `calc(100% - ${width}px)`};
                default:
                    return {};
            }
        },
        /**
         * 观察滚动条变化
         */
        observeScrollbarChanges() {
            // 使用 MutationObserver 监听 CSS 变量变化
            this.scrollbarObserver = new MutationObserver(() => {
                this.updateScrollbarInfo();
            });

            this.scrollbarObserver.observe(document.documentElement, {
                attributes: true,
                attributeFilter: ['style']
            });
        },
        /**
         * 更新滚动条信息
         */
        updateScrollbarInfo() {
            const {getCurrentScrollbarWidth, hasScrollbar} = require('../utils/utils.js');
            this.scrollbarWidth = getCurrentScrollbarWidth();
            this.scrollbarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--scrollbar-height')) || 0;
            this.hasScrollbar = hasScrollbar();
        },
        /**
         * 退出登录
         * @param {Object} store
         * @param {Object} router
         */
        logout() {
            this.$store.commit("SET_LOGIN", false);
            this.$utls.clearCookie("token");
            this.$store.commit("SET_TOKEN", false);
            this.$store.commit("SET_USERINFO", {});
            this.$router.push("/");
        },
        /**
         * 判断是否登录
         * @returns {Boolean} 是否登录
         */
        mixCheckLogin() {
            if (!this.$store.getters.isLogin) {
                this.$confirm('登录后即可查看详细信息！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$router.push({path: "/login"});
                })
                return false;
            } else {
                return true;
            }
        },
        /**
         * 判断用户基本资料是否通过审核，未通过则跳转到详情页
         * @param {Boolean} showTip 是否弹窗提示，默认true
         * @returns {Boolean} 是否通过审核
         */
        mixCheckUserAudit(showTip = true) {
            if (!this.$store.getters.userInfo.mobile) {
                this.$confirm("请先绑定手机号", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.$router.push({path: "/bindPhone"});
                })
                return false;
            }
            if (this.$store.getters.userInfo.status != 1) {
                this.$message.error('您的账号已被禁用')
                return false
            }
            if (this.is_check == 0 || this.is_check == undefined) {
                if (showTip && this.$confirm) {
                    this.$confirm("审核还未通过，请耐心等待！", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        this.$router.push({path: "/user/base-info"});
                    });
                }
                return false;
            } else if (this.$store.getters.is_check == -1) {
                this.$confirm("审核不通过，请修改后重新提交", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.$router.push({path: "/user/base-info"});
                });
                return false;
            } else if (this.$store.getters.is_check == 2) {
                this.$confirm("请完善个人资料", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.$router.push({path: "/user/base-info"});
                });
                return false;
            } else {
                return true;
            }
        },

        // 页面滚动管理方法
        scrollToTop() {
            // 使用平滑滚动到顶部
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },

        scrollToElement(selector, offset = 0) {
            const element = document.querySelector(selector);
            if (element) {
                const elementTop = element.offsetTop - offset;
                window.scrollTo({
                    top: elementTop,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        },

        resetPageScroll() {
            // 刷新页面滚动位置
            this.$nextTick(() => {
                this.scrollToTop();
            });
        }
    },

};
